var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.207,
    height: 81.526,
    viewBox: "0 0 83.207 81.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fda73a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.005.385a8.087,8.087,0,0,0-8.314,7.831,8.081,8.081,0,0,0,8.314,7.826,8.083,8.083,0,0,0,8.317-7.826A8.092,8.092,0,0,0,40.005.385Zm0,72.129a4.707,4.707,0,1,0,4.986,4.7A4.851,4.851,0,0,0,40.005,72.514ZM3.386,39.58a3.138,3.138,0,1,0,0,6.265,3.138,3.138,0,1,0,0-6.265Zm73.23-3.135A6.276,6.276,0,1,0,83.27,42.71,6.469,6.469,0,0,0,76.616,36.445ZM15.872,19.979a2.247,2.247,0,0,0,0-3.323,2.6,2.6,0,0,0-3.524,0,2.255,2.255,0,0,0,0,3.323A2.592,2.592,0,0,0,15.872,19.979ZM61.779,63.228a5.262,5.262,0,0,0,0,7.756,6.074,6.074,0,0,0,8.228,0,5.262,5.262,0,0,0,0-7.756A6.085,6.085,0,0,0,61.779,63.228ZM11.17,64.335a3.766,3.766,0,0,0,0,5.542,4.339,4.339,0,0,0,5.879,0,3.766,3.766,0,0,0,0-5.542A4.339,4.339,0,0,0,11.17,64.335ZM71.187,23.3a6.763,6.763,0,0,0,0-9.967,7.819,7.819,0,0,0-10.585,0,6.763,6.763,0,0,0,0,9.967A7.814,7.814,0,0,0,71.187,23.3Z",
    transform: "translate(-0.063 -0.385)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.ac03a63c8b559a952aa2da57561e2aca.svg";
export { ForwardRef as ReactComponent };